import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { map } from 'rxjs';
import { CommonModule } from '@angular/common';
import { ModuleContainerDirective } from 'src/app/modules/directives/module-container.directive';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-jobs-page',
  standalone: true,
  imports: [CommonModule, ModuleContainerDirective],
  templateUrl: './jobs-page.component.html',
  styleUrl: './jobs-page.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class JobsPageComponent {
  private readonly route = inject(ActivatedRoute);
  public readonly data$ = this.route.data.pipe(map(d => d['data']));
}
